import {createAction} from 'redux-actions'

const action = name => createAction(`my-industry-star/${name}`)

export const addIndustry = action('ADD_INDUSTRY')
export const removeIndustry = action('REMOVE_INDUSTRY')
